var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 66,
    viewBox: "0 0 80 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 0H6C2.7 0 0 2.7 0 6V48C0 51.3 2.7 54 6 54H28V58.2C27.9 58.6 27.1 59.7 26.7 60.2C25.6 61.6 24.5 63 25.3 64.6C25.6 65.3 26.4 66 28 66H51C52 66 54.3 66 55.1 64.2C55.9 62.4 54.5 61 53.3 59.7C52.9 59.2 52.2 58.5 52 58.1V54H74C77.3 54 80 51.3 80 48V6C80 2.7 77.3 0 74 0ZM30.3 62C31.2 60.9 32 59.6 32 58.2V54H48V58.2C48 59.6 49 60.9 50 62H30.3ZM76 48C76 49.1 75.1 50 74 50H6C4.9 50 4 49.1 4 48V42H76V48ZM76 38H4V6C4 4.9 4.9 4 6 4H74C75.1 4 76 4.9 76 6V38Z",
    fill: "#1AA6AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.661af4543ccc43a07d84dd9d782b4579.svg";
export { ForwardRef as ReactComponent };